import React, { useCallback } from "react";
import WithAjax from "../../../common/helpers/WithAjax";

const TalentSamplesManageButton = (props) => {
  const onManageBtnClick = useCallback(
    () => {
      requestNewOrGetSamplesFolderUrlApiCall(props.ajax, props.skillVendorId, props.profileData.ProfileType, (response) => {
        if (response.ok) {
          response.text().then((value) => {
            window.open(value, "_blank");
          });
        }
      });
    },
    [props]
  );

  return (
    <button style={{ marginTop: "15px" }} className="btn btn-primary btn-rounded" type="button" onClick={() => onManageBtnClick()}>
      MANAGE
    </button>
  );
};

const requestNewOrGetSamplesFolderUrlApiCall = (ajax, skillVendorId, profileType, onSuccess) => {
  ajax.post(`skillvendors/${skillVendorId}/requestnewsamplesfolderurl/${profileType}`, null, null, (response) => {
    onSuccess(response);
  });
};

export default WithAjax(TalentSamplesManageButton);
